import { render } from "./input-phone-login.vue?vue&type=template&id=d9c97e4e"
import script from "./input-phone-login.vue?vue&type=script&lang=js"
export * from "./input-phone-login.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__